export const namespace = 'creativeMapping';

export const Status = {
  INITIAL: 'initial',
  LOADING: 'loading',
  LOADED: 'loaded',
  ERROR: 'error'
};

export const ActionType = {
  SET_CREATIVE_SDOS: `${namespace}/SET_CREATIVE_SDOS`,
  SET_CREATIVE_SDO_STATUS: `${namespace}/SET_CREATIVE_SDOS_STATUS`,
  LOAD_CREATIVE_SDOS: `${namespace}/LOAD_CREATIVE_SDOS`
};

export const setCreativeSDOs = (creativeSDOs = []) => ({
  type: ActionType.SET_CREATIVE_SDOS,
  payload: {
    creativeSDOs
  }
});

export const loadCreativeSDOs = () => ({
  type: ActionType.LOAD_CREATIVE_SDOS
});

export const setCreativeSDOStatus = (status) => ({
  type: ActionType.SET_CREATIVE_SDO_STATUS,
  payload: {
    status
  }
})
